<template>
  <div class='h-toolbarBg'>
    <ejs-toolbar>
      <e-items>
        <e-item prefixIcon='icon hero-icon hero-icon-topo-tcf' :tooltipText='$t("System.onlyBackup")' :click='notices' eventType='backup'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click='notices' eventType='refresh'></e-item>
      </e-items>
    </ejs-toolbar>
    <ejs-textbox  :placeholder='$t("System.inputTip21")' @keydown.enter.native="search" v-model='input' width="300px"/>
  </div>
</template>

<script>
export default {
  name: "ConfigBackupTableButton",
  data() {
    return {
      input: '',
    }
  },
  props: {
  },
  methods: {
    notices(args) {
      this.$emit('notice', args.item.eventType);
    },
    search() {
      this.$emit('transmitInput', this.input);
    }
  }
}
</script>

<style scoped>

</style>
